import { Link } from "react-router-dom";

import { Trans } from "@arc/i18n";

export const NoWalletErrorToast: React.FC<{ onClick: () => void }> = ({ onClick }) => (
  <div>
    <Trans
      components={[
        <Link key="secret-key" className="text-accent" to="/import?mode=secret-key" onClick={onClick} />,
        <Link key="existing" className="text-accent" to="/import?mode=existing" onClick={onClick} />,
      ]}
      i18nKey="ERRORS.NO_WALLET_ERROR"
      ns="bank"
    />
  </div>
);
